var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-content',[_c('stamped-io-feed',{attrs:{"show-at-page":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }